import { sanitizeOptions } from '../../../../common/components/EmailInputRecipient/helper'
import { Recipient } from '../../../../common/types/form'
import { recipientGroupSingleValidations } from '../../../validations'
import { RecipientModificationAction, RecipientModifications } from "./types"


export const applySingleModification = (modification: RecipientModifications): Recipient => {

    if (!modification ||  typeof modification !== 'object'  || modification == null || !modification.groupName){    
        return undefined
    }

    let lookups = {
        ...(modification.currentRecipient?.lookups ?? {}),
    }
    Object.entries((modification.importedRecipient?.lookups ?? {})).forEach(([macro, keys]) => {
        const mergedKeys = [...(lookups[macro] ?? []), ...(keys ?? [])]
        lookups = {
            ...lookups,
            [macro]: [...new Set(mergedKeys)]
        }
    })
    Object.keys(lookups)
        .filter(key => !key || !lookups[key])
        .forEach(key => delete lookups[key])

    switch (modification.action) {
        case RecipientModificationAction.ADDED:
            return modification.importedRecipient
        case RecipientModificationAction.PRESERVED:
            return modification.currentRecipient
        case RecipientModificationAction.OVERRIDED:
            return {
                uuid: modification.currentRecipient?.uuid,
                ...(modification.importedRecipient ?? {})
            } as Recipient
        case RecipientModificationAction.UPDATED:
            return {
                uuid: modification.currentRecipient?.uuid,
                enabled: modification.importedRecipient?.enabled,
                name: modification.importedRecipient?.name,
                recipients: sanitizeOptions([...new Set([...(modification.currentRecipient?.recipients ?? []), ...(modification.importedRecipient?.recipients ?? [])])]),
                lookups: {
                    ...lookups
                }
            }
        case RecipientModificationAction.DELETED:
        default:
            return undefined
    }
}

export const applyAllModifications = (recipientsModifications: RecipientModifications[]): Recipient[] => {
    return recipientsModifications
        .map(applySingleModification)
        .filter(recipient => !!recipient)
}

export const validateModificationAction = (modification: RecipientModifications): string[] => {
    const resultRecipient = applySingleModification(modification)
    if(resultRecipient)
        return recipientGroupSingleValidations(resultRecipient, resultRecipient.name)
    return []
}